import { render, staticRenderFns } from "./DocumentsSuccess.vue?vue&type=template&id=06a9432e&scoped=true"
import script from "./DocumentsSuccess.vue?vue&type=script&lang=js"
export * from "./DocumentsSuccess.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSuccess.vue?vue&type=style&index=0&id=06a9432e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9432e",
  null
  
)

export default component.exports